import DOMPurify from 'dompurify';
import mermaid from 'mermaid';

export const FlowchartUtil = {
  /** Strips `foreignObject`, which is why `htmlLabels` is off below - nothing is left to take. */
  sanitize({ svg }: { svg: string }) {
    return DOMPurify.sanitize(svg, { RETURN_DOM_FRAGMENT: true });
  },

  /** The source is model output and reaches the page as markup, so `strict` is the point here. */
  async toFragment({ code, id }: { code: string; id: string }) {
    mermaid.initialize({
      /* `useMaxWidth` sizes the svg as a percentage, which collapses in the item that centers it. */
      flowchart: { htmlLabels: false, useMaxWidth: false },
      /* Needed here as well as on `flowchart`, or node labels keep their `foreignObject`. */
      htmlLabels: false,
      securityLevel: 'strict',
      startOnLoad: false,
      /* Left unthemed: `Flowchart.less` repaints it, where a theme can reach the colors. */
      theme: 'base',
    });

    const { svg } = await mermaid.render(id, code);

    return FlowchartUtil.sanitize({ svg });
  },
};
